export default {
    title: 'orderedList',
    action: [ 'insertOrderedList' ],
    description: 'Ordered List (1, 2, 3)',
    icon: 'Ol',
};
